import { createContext } from 'react';
import { Listing } from '../../../../../models/Listing';
import utils from 'utils';
import { DeepPartial } from 'types';

type PatchListingContextProps = {
  patchListingValue: (
    value: DeepPartial<Listing> | Record<string, any>,
    updatedValues?: Partial<Listing>,
  ) => void;
};

export default createContext<Partial<PatchListingContextProps>>({
  patchListingValue: utils.noop,
});
